export enum ChipType {
    Blue = "Blue",
    Yellow = "Yellow",
}
